var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1732_96338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1732_96338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.332L5.83334 9.16536L7.00001 7.95703L9.16668 10.1237V3.33203H10.8333V10.1237L13 7.95703L14.1667 9.16536L10 13.332ZM5.00001 16.6654C4.54168 16.6654 4.14932 16.5022 3.82293 16.1758C3.49654 15.8494 3.33334 15.457 3.33334 14.9987V12.4987H5.00001V14.9987H15V12.4987H16.6667V14.9987C16.6667 15.457 16.5035 15.8494 16.1771 16.1758C15.8507 16.5022 15.4583 16.6654 15 16.6654H5.00001Z",
    fill: "#068EFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.cc4b733254b4fa99304185375a8cf5fe.svg";
export { ForwardRef as ReactComponent };